var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAssetMap = function SvgAssetMap(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 44.2716V15.0902C6 14.6392 6.28797 14.2386 6.71543 14.0949L17.2154 10.5653C17.8958 10.3366 18.6 10.8428 18.6 11.5606V40.2377C18.6 40.6723 18.3323 41.062 17.9266 41.2179L7.42656 45.2518C6.73886 45.516 6 45.0083 6 44.2716Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 41.282V9.6687C22.8 8.89553 23.6074 8.38752 24.3044 8.7221L32.7044 12.7541C33.0685 12.9288 33.3 13.2969 33.3 13.7007V44.306C33.3 45.0333 32.5786 45.5403 31.8944 45.294L23.4944 42.27C23.0778 42.12 22.8 41.7248 22.8 41.282Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 42.149V14.4499C37.5 14.0012 37.7851 13.6021 38.2095 13.4566L46.6095 10.5766C47.291 10.3429 48 10.8494 48 11.5699V38.789C48 39.2183 47.7386 39.6044 47.34 39.7639L38.94 43.1239C38.2503 43.3997 37.5 42.8918 37.5 42.149Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssetMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asset-map.47a9b699.svg";
export { ForwardRef as ReactComponent };